import { colors } from '@/lib/analytics/colors';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsReachRateMVConfig: KpiType<typeof MediaViewerKpiLoader, typeof MediaViewerKPI> = {
    name: 'kpi.facebook.reach_rate',
    id: 'reach_rate',
    icon: {
        name: 'reach',
        style: colors.yellow
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    element: MediaViewerKPI,
    loader: MediaViewerKpiLoader
};
